import Vue from 'vue';
import axios from 'axios'; 
import '../filters';
import users from '../users';
import { kebabCase, range, random } from 'lodash/fp';
import VueLayers from 'vuelayers';
//import { core as vlCore } from 'vuelayers';

export default {
  name: 'Map',
  mixins: [users],
  data: function () {
    return {
      layers: [],    // wms layers
      layersDef: [], // layers defs from db
      map: {},
      command: '',
      cmdParams: {},
      mapOptions: { center: [0, 0], zoom: 4, rotation: 0, projection: 'EPSG:3857' },
      message: '',
      coord: {},
      highlitedLines: {},
      highlitedPoints: {},
      highlitedAreas: {},
    }
  },
  created() {
    this.command = this.$route.params.command;
    if (!this.command || this.command == '')
      this.command = 'zoomToMap';
    this.cmdParams = this.$route.params;
    this.getMapDef();
  },
  methods: {
    geometryTypeToCmpName(type) {
      return 'vl-geom-' + kebabCase(type)
    },
    execCommand() {
      var m = this.$refs.map;
      switch (this.command) {
        case 'zoomToLayer': // params: { name: name }
          var name = this.cmdParams.param.name;
          var ls = this.layersDef.filter((l) => { return l.name == name ; });
          if (ls && ls.length > 0) {
            var layer = ls[0];
            this.mapOptions.center = [(layer.mapExtent[0] + layer.mapExtent[2]) / 2, (layer.mapExtent[1] + layer.mapExtent[3]) / 2];
            m.$view.fit(layer.mapExtent);
          }
          break;

        case 'zoomToElement': // params: { type: type. id: id, clearAll: true/false }
          var p = { type: -1, id: -1, clearAll: false };
          if (this.cmdParams.param.type == undefined || this.cmdParams.param.type < 0)
            p = JSON.parse(this.cmdParams.param)
          else
            p = this.cmdParams.param;
          if (p.type >= 0 && p.id >= 0) {
            axios.post('/GIS/GetElementFeature', { ElementType: p.type, ElementId: p.id })
              .then(response => {
                if (response.data.data.status == 0) {
                  var feature = response.data.item;
                  this.mapOptions.center = [(feature.mapExtent[0] + feature.mapExtent[2]) / 2, (feature.mapExtent[1] + feature.mapExtent[3]) / 2];
                  this.mapOptions.zoom = 16;

                  setTimeout(() => {
                    var layers = this.layers.filter((l) => l.id == feature.layerId);
                    if (layers && layers.length > 0) {
                      var highlitedLayer = { source: { staticFeatures: [] } };
                      switch (layers[0].geometryType) {
                        case 'point':
                          highlitedLayer = this.highlitedPoints;
                          break;
                        case 'line':
                          highlitedLayer = this.highlitedLines;
                          break;
                        case 'polygon':
                          highlitedLayer = this.highlitedAreas;
                          break;
                      }
                      if (highlitedLayer) {
                        if (p.clearAll)
                          highlitedLayer.source.staticFeatures = [];

                        var type = layers[0].geometryType;
                        if (type == 'line')
                          type = 'line_string';
                        if (type == 'point')
                          feature.mapGeometry = feature.mapGeometry[0];

                        var f = {
                          id: feature.featureId, properties: {}, geometry: { type: type, coordinates: feature.mapGeometry }
                        };
                        highlitedLayer.source.staticFeatures.push(f);

                      }
                      else
                        this.$alertMsg(this.$t('messages.NotSupportedGeometryType') + layers[0].geometryType, 1);
                    }
                    else
                      this.$alertMsg(this.$t('messages.Layer') + feature.layerName + this.$t('messages.NotFoundOnMap'), 1);

                  }, 100);
                }
                else
                  this.$alertMsg(response.data.data.text);
              })
              .catch(e => { this.$router.push('/login'); return false; })
          }
          else
            this.$alertMsg(this.$t('messages.NoElementDetailsProvided'));
          break;

        default: //'zoomToMap'
          var m = this.$refs.map;
          this.mapOptions.center = [(this.map.extent[0] + this.map.extent[2]) / 2, (this.map.extent[1] + this.map.extent[3]) / 2];
          m.$view.fit(this.map.extent);
          break;
      }
    },
    getMapDef() {
      axios.post('/GIS/GetMapDef')
        .then(response => {
          if (response.data.data.status == 0) {
            this.map = response.data.map;
            this.mapOptions.projection = this.map.projection;
            this.layersDef = response.data.layers;
            this.layers = [];
            //this.layersDef.forEach((lyr) => {
            //  var layer = {
            //    id: lyr.id, title: lyr.name, cmp: 'vl-layer-tile', visible: true, geometryType: lyr.geometryType,
            //    source: {
            //      cmp: 'vl-source-wms',
            //      url: lyr.link,
            //      layers: lyr.gisName,
            //      extParams: { TILED: true },
            //      serverType: 'geoserver',
            //    }
            //  };
            //  this.layers.push(layer);
            //});

            this.layersDef.forEach((lyr) => {
              var layer = {
                id: lyr.id, title: lyr.name, cmp: 'vl-layer-vector', visible: true, geometryType: lyr.geometryType,
                source: {
                  cmp: 'vl-source-vector',
                  url: 'http://localhost:8091/geoserver/wfs?service=wfs&version=1.1.0&request=GetFeature&typename=' + lyr.gisName + '&outputFormat=application/jsonp',
                },
                renderMode: 'vector'
              };
              this.layers.push(layer);
            });

            this.highlitedLines = {
              id: 'highlitedLines', title: 'Highlighted line elements', cmp: 'vl-layer-vector', visible: true, geometryType: 'line',
              source: {
                cmp: 'vl-source-vector',
                url: '',
                layers: '',
                extParams: { TILED: false },
                serverType: 'geoserver',
                staticFeatures: [],
              },
              style: [
                {
                  cmp: 'vl-style-box',
                  styles: {
                    'vl-style-stroke': {
                      color: 'purple',
                      width: 6,
                    },
                  },
                },
              ],
            };
            this.layers.push(this.highlitedLines);

            this.highlitedPoints = {
              id: 'highlitedPoints', title: 'Highlighted point elements', cmp: 'vl-layer-vector', visible: true, geometryType: 'point',
              source: {
                cmp: 'vl-source-vector',
                url: '',
                layers: '',
                extParams: { TILED: false },
                serverType: 'geoserver',
                staticFeatures: [],
              },
              style: [
                {
                  cmp: 'vl-style-func',
                  factory: this.getPointStyle,
                },
              ],
            };
            this.layers.push(this.highlitedPoints);

            this.highlitedAreas = {
              id: 'highlitedAreas', title: 'Highlighted area elements', cmp: 'vl-layer-vector', visible: true, geometryType: 'polygon',
              source: {
                cmp: 'vl-source-vector',
                url: '',
                layers: '',
                extParams: { TILED: false },
                serverType: 'geoserver',
                staticFeatures: [],
              },
              style: [
                {
                  cmp: 'vl-style-box',
                  styles: {
                    'vl-style-fill': {
                      color: [255, 255, 255, 0.5],
                    },
                    'vl-style-stroke': {
                      color: 'purple',
                      width: 3,
                    },
                  },
                },
              ],
            };
            this.layers.push(this.highlitedAreas);

            setTimeout(() => {
              this.execCommand();
            }, 100);
          }
          else
            this.$alertMsg(response.data.data.text);
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },

    getPointStyle() {
      return function __getPointStyle(feature) {
        return [
          VueLayers.core.styleHelper.style({
            imageRadius: 6,
            imageFillColor: 'purple',
          }),
        ]
      }
    },

    test(f, l) {
      var a = f;
    },
    mapClick(event) {
//      console.log(event);
      this.coord = event.coordinate;
      var m = this.$refs.map;
      var features = [];
      m.forEachFeatureAtPixel(event.pixel, function (feature, layer) {
        features.push(feature);
        console.log(feature);
      }, { hitTolerance: 10 });

      var a = 11;
    },

  },
}
